exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#tabNavigation {\r\n  line-height: 2rem;\r\n  border-bottom: 1px solid #ccc;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-grow: 0;\r\n  justify-content: space-between;\r\n}\r\n\r\n#tabNavigation h1 {\r\n  padding: 0.5rem;\r\n  margin: 0;\r\n  text-transform: uppercase;\r\n  font-size: 1rem;\r\n  font-weight: bold;\r\n}\r\n\r\n#tabs {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n  padding: 0;\r\n  margin: 0;\r\n}", ""]);

// exports
